<script lang="ts" setup>
const props = defineProps({
  alignment: {
    default: 'left',
    type: String as PropType<CompanyAppsAlignment>,
  },
  contacts: {
    default: () => ({}),
    type: Object as PropType<CompanyV2Contacts>,
  },
  hasTooltip: {
    default: false,
    type: Boolean,
  },
  max: {
    default: Number.POSITIVE_INFINITY,
    type: Number,
  },
  reorder: {
    default: true,
    type: Boolean,
  },
  size: {
    default: 'sm',
    type: String as PropType<CompanyAppsSize>,
  },
})

const { t } = useI18n()

const order: ('contactUrl' | CompanyContactsKeys)[] = [
  'contactUrl',
  'emails',
  'lines',
  'phones',
  'whatsapps',
]

const formattedApps = computed(() => {
  return Object.entries(props.contacts)
    .filter(([contactName]) => order.includes(contactName as CompanyContactsKeys))
    .flatMap(([contactName, contactValue]) => {
      if (contactName === 'contactUrl') {
        return [
          {
            category: 'general',
            name: contactName,
            type: contactName,
            url: contactValue || '',
          },
        ]
      }

      return (contactValue as any[] || []).map(contact => ({
        category: contact.category || '',
        name: contact.value || '',
        type: contactName,
        url: contact.value || '',
      }))
    })
    .sort((current, next) => {
      if (!props.reorder) {
        return 0
      }

      return order.indexOf(current.type as CompanyContactsKeys) - order.indexOf(next.type as CompanyContactsKeys)
    })
    .slice(0, props.max)
})
</script>

<template>
  <div
    class="flex flex-wrap items-center"
    :class="{
      'justify-start': alignment === 'left',
      'justify-center': alignment === 'center',
      'justify-end': alignment === 'right',
      'gap-1.5': size === 'xs',
      'gap-2': size === 'sm',
      'gap-3': size === 'lg',
      'gap-4': size === 'xl',
    }"
  >
    <template v-for="(app, appIndex) in formattedApps">
      <UTooltip
        v-if="appIndex < max"
        :key="app.name"
        :text="hasTooltip ? `${t(`contacts.${app.type}`)} (${t('globals.clickToShow')})` : ''"
      >
        <ULink
          :class="{
            'size-4': size === 'xs',
            'size-5': size === 'sm',
            'size-6': size === 'lg',
            'size-7': size === 'xl',
          }"
          target="_blank"
          :to="app?.url"
        >
          <UIcon
            :class="{
              'size-4': size === 'xs',
              'size-5': size === 'sm',
              'size-6': size === 'lg',
              'size-7': size === 'xl',
            }"
            :name="getIcon(app.type as UIcon)"
          />
        </ULink>
      </UTooltip>
    </template>
  </div>
</template>
